










import { Vue, Component, Prop } from "vue-property-decorator";
import EnterpriseDetails from "../components/Profile/EnterpriseDetails.vue";
import InstituteDetails from "../components/Profile/InstituteDetails.vue";
import * as user from "../_store/user.module";
import * as auth from "../_store/auth.module";
import { bus } from "../main";
import { userUtils } from "../_utils/userUtils";
import { InstituteInfo } from "../_models/instituteInfo";

@Component({
  components: {
    EnterpriseDetails,
    InstituteDetails
  }
})
export default class Appartenenza extends Vue {
  @Prop() tipoSoggetto!: number;
  private instituteData: InstituteInfo

  constructor(){
    super();
    this.instituteData = {
      id: 0,
      ragioneSocialeIstituto: "",
      indirizzoIstituto: "",
      capComuneIstituto: "",
      provinciaIstituto: "",
      nazioneIstituto: "",
      comuneIstituto: "",
      telefono1Istituto: "",
      telefono2Istituto: "",
      emailIstituto: "",
      pecIstituto: "",
      codIstituto: "",
      codMinisterialeIstituto: "",
      dirigenteIstituto: ""
    }
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    if (payload.tipoSoggetto === 4) {
      user
        .dispatchSetStudentInfo(this["$store"], payload)
        .then(() => {
          // user.dispatchSetInstituteInfo(this["$store"]).then(() =>{
          //   this.instituteData = user.readInstituteInfo(this["$store"])
      
          // })
          bus.$emit("loadMenu");
        })
        .catch(() => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    } else {
      user
        .dispatchSetUserInfo(this["$store"], payload)
        .then(() => {
          bus.$emit("loadMenu");
        })
        .catch(() => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    }
  }
}
